export const PING_QUERY_KEY = ['ping'] as const;

export const PING_ENDPOINT = '/ping';
